module.exports = __webpack_public_path__ + "static/media/PrevMonthIcon.9d375bfa.svg";